import { FieldDefinition } from "./fieldDefinitions";

export interface PatientRehabProtocolDto {
  patientRehabId: number;
  rehabId: number;
  patientId: number;
  encounterId?: number | null;
  totalSessionsPrescribed: number;
  sessionsCompleted: number;
  status: string;
  protocolType: string;
}

export const patientRehabKeyId = "patientRehabId" as const;

export const patientRehabProtocolFormData: string[] = [
  "rehabId",
  "patientId",
  "encounterId",
  "totalSessionsPrescribed",
  "sessionsCompleted",
  "status",
  "protocolType",
];

export const getPatientRehabProtocolFields = (
  options: Array<{ value: string | number; label: string }> = [],
): FieldDefinition[] => [
  {
    name: "rehabId",
    label: "Τύπος Πρωτοκόλλου",
    type: "select",
    required: true,
    options,
  },
  { name: "status", label: "Κατάσταση", type: "text", required: true },
  {
    name: "totalSessionsPrescribed",
    label: "Συνολικές Συνεδρίες",
    type: "number",
    required: true,
  },
  {
    name: "sessionsCompleted",
    label: "Ολοκληρωμένες Συνεδρίες",
    type: "number",
    required: true,
  },
];

export const patientRehabProtocolFields = getPatientRehabProtocolFields();

export const patientRehabProtocolFilters = patientRehabProtocolFields.filter(
  (f) => ["rehabId", "status"].includes(f.name),
);
